export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      noticeTypeMsts: [
        {
          noticeTypeMstId: 13,
          noticeTypeMstUuid: 'noticeType013',
          noticeTypeName: '防災メルマガ',
          noticeType: 'disaster',
          screenId: 'BUSCF00015',
          screenIdMstUuid: 'screenidmst001',
          noticeTypeStatus: 1
        },
        {
          noticeTypeMstId: 12,
          noticeTypeMstUuid: 'noticeType012',
          noticeTypeName: '警戒レベル告知',
          noticeType: 'keikai',
          screenId: 'BUSCF00025',
          screenIdMstUuid: 'screenidmst002',
          noticeTypeStatus: 1
        },
        {
          noticeTypeMstId: 11,
          noticeTypeMstUuid: 'noticeType011',
          noticeTypeName: '御用聞き',
          noticeType: 'ordertake',
          screenId: 'BUSCF00026',
          screenIdMstUuid: 'screenidmst003',
          noticeTypeStatus: 1
        },
        {
          noticeTypeMstId: 10,
          noticeTypeMstUuid: 'noticeType010',
          noticeTypeName: '見守り',
          noticeType: 'follow',
          screenId: 'BUSCF00029',
          screenIdMstUuid: 'screenidmst004',
          noticeTypeStatus: 1
        },
        {
          noticeTypeMstId: 9,
          noticeTypeMstUuid: 'noticeType009',
          noticeTypeName: '動画のみ',
          noticeType: 'movies',
          screenId: 'BUSCF00033',
          screenIdMstUuid: 'screenidmst005',
          noticeTypeStatus: 1
        },
        {
          noticeTypeMstId: 8,
          noticeTypeMstUuid: 'noticeType008',
          noticeTypeName: '画像のみ',
          noticeType: 'images',
          screenId: 'BUSCF00015',
          screenIdMstUuid: 'screenidmst001',
          noticeTypeStatus: 1
        },
        {
          noticeTypeMstId: 7,
          noticeTypeMstUuid: 'noticeType007',
          noticeTypeName: '音声定時放送',
          noticeType: 'sound_broadcast',
          screenId: 'BUSCF00015',
          screenIdMstUuid: 'screenidmst001',
          noticeTypeStatus: 1
        },
        {
          noticeTypeMstId: 6,
          noticeTypeMstUuid: 'noticeType006',
          noticeTypeName: 'アンケート',
          noticeType: 'opinionaire',
          screenId: 'BUSCF00015',
          screenIdMstUuid: 'screenidmst001',
          noticeTypeStatus: 1
        },
        {
          noticeTypeMstId: 5,
          noticeTypeMstUuid: 'noticeType005',
          noticeTypeName: '音声告知',
          noticeType: 'sound',
          screenId: 'BUSCF00015',
          screenIdMstUuid: 'screenidmst001',
          noticeTypeStatus: 1
        },
        {
          noticeTypeMstId: 4,
          noticeTypeMstUuid: 'noticeType004',
          noticeTypeName: 'PDF',
          noticeType: 'pdf',
          screenId: 'BUSCF00015',
          screenIdMstUuid: 'screenidmst001',
          noticeTypeStatus: 1
        },
        {
          noticeTypeMstId: 3,
          noticeTypeMstUuid: 'noticeType003',
          noticeTypeName: '動画添付',
          noticeType: 'text_movie',
          screenId: 'BUSCF00015',
          screenIdMstUuid: 'screenidmst001',
          noticeTypeStatus: 1
        },
        {
          noticeTypeMstId: 2,
          noticeTypeMstUuid: 'noticeType002',
          noticeTypeName: '画像添付',
          noticeType: 'text_image',
          screenId: 'BUSCF00015',
          screenIdMstUuid: 'screenidmst001',
          noticeTypeStatus: 1
        },
        {
          noticeTypeMstId: 1,
          noticeTypeMstUuid: 'noticeType001',
          noticeTypeName: 'テキストのみ',
          noticeType: 'text',
          screenId: 'BUSCF00015',
          screenIdMstUuid: 'screenidmst001',
          noticeTypeStatus: 1
        }
      ]
    }
  }
}